import FullScreenCard from '../../shared/FullScreenCard';
import GeneralContext from '../../../context/GeneralContext';
import { useContext, useEffect, useState } from 'react';
import { fetchGet, fetchBody } from '../../../utils/fetch';
import Table from '../../shared/Table';

function ActiveUsers() {

    const {
        changeModalTitle,
        changeModalType,
        changeModalText,
        changeModalFunction1,
        changeCurrentMenu,
        setUserResetData
    } = useContext(GeneralContext);

    const [headers, setHeaders] = useState([
        {id: 'header0', text: 'Alerta'}
    ]);

    const [activeUsersList, setActiveUsersList] = useState([
        {id: '1a', fields: [
            {id: '0', text: 'Error conectándose al servidor'}
          ]
        }
    ]);

    const [tableType, setTableType] = useState('display');

    const prepareUserList = (list) => {
        setHeaders([
            {id: 'header0', text: 'Nombre'},
            {id: 'header1', text: 'Documento'},
            {id: 'header2', text: 'Rol'},
        ]);
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === 'active') {
                let role = '';
                if (list[i].role === 'user') {role = 'Usuario'};
                if (list[i].role === 'admin') {role = 'Administrador'};
                if (list[i].role === 'super_admin') {role = 'Súper Administrador'};
                const item = {
                    id: list[i].id,
                    fields: [
                        {id: '0', text: list[i].last_name + ' ' + list[i].first_name},
                        {id: '1', text: list[i].document},
                        {id: '2', text: role}
                    ]
                }
                newList.push(item);
            }
        }
        setActiveUsersList(newList);
        setTableType('actions');
    }

    useEffect(() => {
        const getUsersList = async () => {
            const response = await fetchGet('');
            if (response.success) {
                prepareUserList(response.list);
            }
        }
        getUsersList();
    }, []);


    const deactivateUser = (id) => {
        const modal = document.getElementById("myModal");
        changeModalFunction1(() => async () => {
            const fetchData = {
                id: id,
                status: 'inactive'
            }
            const response = await fetchBody('', 'PUT', fetchData);
            if (response.success) {
                changeCurrentMenu('manage-users');
                modal.style.display = "none";
            } else {
                changeModalTitle('Error al intentar desactivar usuario');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        })
        changeModalTitle('Desactivando al usuario');
        changeModalType('confirm');
        modal.style.display = "block";
    }

    const restoreUser = (id, fields) => {
        setUserResetData({id: id, name: fields[0].text});
        changeCurrentMenu('restore-user');
    }

    const activeUserActions = [
        {
            id: 0,
            text: 'Desactivar',
            buttonFunction: deactivateUser
        },
        {
            id: 1,
            text: 'Restablecer',
            buttonFunction: restoreUser
        }
    ]

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-users'}>
        <h1>Usuarios Activos</h1>
        <Table
            headers={headers}
            data={activeUsersList}
            type={tableType}
            actions={activeUserActions}
            actionsClass='doubleColumnAuto'
        />
    </FullScreenCard>
  )
}

export default ActiveUsers